import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { imageUrls } from "../constants/images";
import { Texterror } from "../constants/Texterror";
import "../../styles/auth.scss";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Apis, BaseUrl } from "../redux/config";
import { toast } from "react-toastify";
import { SignIn } from "../constants/Validation";

export const SharedLogin = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const getProfile = async (email) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${BaseUrl}${Apis.getProfile}${email}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.usr.rec[0];
    } catch (error) {
      toast.error(
        error.response?.data?.usr?.message || "Error fetching profile"
      );
    }
  };

  const handleLogin = async (values) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}${Apis.signin}`, values);
      const userData = response.data.accessToken.usr[0];

      if (!userData) {
        toast.error("Invalid login credentials");
        setIsLoading(false);
        return;
      }

      toast.success("Welcome back " + userData.user_first_name);
      localStorage.setItem("token", response.data.accessToken.token);
      const profileData = await getProfile(userData.user_email);
      const requiredData = {
        payee_name: profileData.user_first_name,
        payee_phone: profileData.user_phone_nbr,
        payee_email: userData.user_email,
        isLogged: true,
        walletBalance: userData.wallet_balance,
      };
      sessionStorage.setItem(
        "payment_user_details",
        JSON.stringify(requiredData)
      );
      const orderId = JSON.parse(sessionStorage.getItem("orderId"));
      const queryString = new URLSearchParams(orderId).toString();
      history.push(`/share_payment?${queryString}`);
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login_ss">
      <Container className="p-3">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col>
            <div className="open_form">
              <div className="main_box">
                <div className="p-5 card-body w-100 d-flex flex-column">
                  <Link to={`/`}>
                    <img
                      src={imageUrls.logo}
                      className="img-fluid"
                      alt="Phone"
                    />
                  </Link>
                  <div className="mini_kog">
                    <h2 className="fw-bold mb-2 text-center">Welcome Back!</h2>
                    <p className="mb-4 text-center">
                      Please enter your email address and password!
                    </p>

                    <Formik
                      initialValues={{ user_email: "", user_password: "" }}
                      validationSchema={SignIn}
                      onSubmit={(values, { resetForm }) => {
                        handleLogin(values);
                        resetForm();
                      }}
                    >
                      {({ values, touched, errors, handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.user_email && errors.user_email
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="user_email"
                              placeholder="Email"
                              type="input"
                              value={values.user_email}
                            />
                            <ErrorMessage
                              name="user_email"
                              component={Texterror}
                            />
                          </div>

                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.user_password && errors.user_password
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Password"
                              name="user_password"
                              type="password"
                              value={values.user_password}
                            />
                            <ErrorMessage
                              name="user_password"
                              component={Texterror}
                            />
                          </div>
                          <button type="submit" className="sign_btn !w-full">
                            {isLoading ? <Spinner /> : "Sign in"}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
              <div className="second_box">
                <img src={imageUrls.signin} alt="doctor" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
